import React from 'react'
import "./publishAndShare.scss"
import ByEmailList from './sections/byEmailList'
import LearnToShare from './sections/learnToShare'
import SectionPublishAndShare from './sections/sectionPublishAndShare'
import SendDashboards from './sections/sendDashboards'
import Letsgo from '../connectors/letsgo'

function PublishAndShare() {
  return (
    <div className='container-publish-and-share'>
      <div className="section-section-publish-and-share">
        <SectionPublishAndShare />
      </div>
      <div className="section-send-dashboards">
        <SendDashboards />
      </div>
      <div className="section-learn-to-share">
        <LearnToShare />
      </div>
      <div className="section-by-email-list">
        <ByEmailList />
      </div>
      <div className="section-letsgo">
        <Letsgo />
      </div>
    </div>
  )
}

export default PublishAndShare